<script lang="ts">
    import InView from "../InView.svelte"
    import { initCryptcha, resetCryptcha, cryptchaSolution, cryptchaSolutionId, getUserCountry } from "../../utils"
    import { location } from "../../store"
    import { getCachedEntries, postDBEntry } from "../../../api"
    import { spaLink } from "../../actions"

    export let block: ContentBlockEntry

    let formData: RaffleFormEntry = {
        type: "raffleForm",
        referrer: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        country: getUserCountry(),
        subject: block.raffleForm?.subject || "Raffle",
        description: "",
        _s: "",
        _sId: "",
    }

    let errorMessage = ""
    let success = false
    let loading = false

    function submit(e: Event) {
        e.preventDefault()
        formData.referrer = $location.path
        formData._s = $cryptchaSolution
        formData._sId = $cryptchaSolutionId

        loading = true
        success = false
        errorMessage = ""

        postDBEntry("form", formData)
            .then(() => {
                success = true
                // clear form
                Object.keys(formData).forEach((key) => {
                    if (key !== "type" && key != "subject") formData[key] = ""
                })
                accepted = false
                if (typeof window !== "undefined") {
                    setTimeout(() => {
                        success = false
                    }, 5000)
                }
            })
            .catch((err) => {
                console.error(err)
                errorMessage = "An error occurred. Please try again later. (" + err.data?.message + ")"
            })
            .finally(() => {
                loading = false
            })

        resetCryptcha()
    }

    let cryptchaEl: HTMLDivElement

    let accepted = false
    let acceptedConditions = false

    let cryptchaInitialized = false

    $: if (cryptchaEl && !cryptchaInitialized && formData.firstname) {
        initCryptcha(cryptchaEl)
        cryptchaInitialized = true
    }
</script>

<div class="container">
    <form on:submit="{submit}">
        <!-- Kontaktformular -->
        <div class="grid">
            <div class="col-md-6 col-grid border-bottom">
                <label for="first">First Name<span>*</span></label>
                <input type="text" id="first" required bind:value="{formData.firstname}" />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="last">Last Name<span>*</span></label>
                <input type="text" id="last" required bind:value="{formData.lastname}" />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="email">E-Mail<span>*</span></label>
                <input type="email" id="email" required bind:value="{formData.email}" />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <!-- Dieses Element ist möglicherweise mit Filterbarem Dropdown? -->
                <label for="country">Country<span>*</span></label>
                {#if typeof window !== "undefined"}
                    {#await getCachedEntries("country", null, "name") then countries}
                        <select id="country" bind:value="{formData.country}" required>
                            <option value="" selected disabled>Please select...</option>
                            {#each countries as country}
                                <option value="{country.code}">{country.name}</option>
                            {/each}
                        </select>
                    {/await}
                {/if}
            </div>
            <div class="col-12 col-grid border-bottom">
                <label for="subject">Subject<span>*</span></label>
                <input type="text" id="subject" required bind:value="{formData.subject}" />
            </div>
            <div class="col-12 col-grid border-bottom">
                <label for="description">Message<span>*</span></label>
                <textarea id="description" required bind:value="{formData.description}"></textarea>
            </div>
            <div class="col-12 col-grid">
                <input type="checkbox" id="optInData" bind:checked="{formData.optInDataUsage}" />
                <!-- TODO: popup to -->
                <label class="checkbox-wrap" for="optInData"
                    ><span
                        >In case of winning, I consent to have my name and country of residence published to the
                        advertising media used by the organiser. This includes the announcement on the website of
                        SPORTident GmbH and its social media platforms.</span
                    ></label
                >
            </div>
            <div class="col-12 col-grid">
                <input type="checkbox" id="conditions" required bind:checked="{acceptedConditions}" />
                <!-- TODO: popup to -->
                <label class="checkbox-wrap" for="conditions"
                    ><span
                        >I have read and agree to the general <a
                            use:spaLink
                            href="{typeof window !== 'undefined' ? window.location.href : ''}#conditions"
                            >conditions of participation</a
                        >. *</span
                    ></label
                >
            </div>
        </div>
        {#if success}
            <div class="success">
                <p>Your message has been sent successfully.</p>
            </div>
        {/if}
        {#if errorMessage}
            <div class="error">
                <p>{errorMessage}</p>
            </div>
        {/if}
        <div class="grid align-center">
            <div class="col-auto privacy">
                <input type="checkbox" id="privacy" required bind:checked="{accepted}" />
                <!-- TODO: popup to -->
                <label class="checkbox-wrap" for="privacy"
                    ><span>Accept <a href="/legal-information" target="_blank">Privacy Policy</a></span></label
                >
            </div>
            <div class="col-auto align-self-end">
                <button
                    type="submit"
                    class="btn-primary"
                    disabled="{!$cryptchaSolution || !acceptedConditions || !accepted || loading}">Send</button
                >
            </div>
        </div>
        <InView>
            <div bind:this="{cryptchaEl}"></div>
        </InView>
    </form>
</div>

<style lang="less">
    button:disabled {
        opacity: 0.5;
    }

    .success {
        background-color: #d4edda;
        color: #155724;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 0.25rem;
    }

    .error {
        background-color: #f8d7da;
        color: #721c24;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 0.25rem;
    }
</style>
